import { render, staticRenderFns } from "./ThePhoneIcon.vue?vue&type=template&id=47190b14&"
import script from "./ThePhoneIcon.vue?vue&type=script&lang=js&"
export * from "./ThePhoneIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports